import { AppViewModel } from '../../app/app.vm';

interface Props {
    appVm: AppViewModel;
}

export default function DiscoverView(props: Props) {
    return <div>discover</div>;
}
